import styled from 'styled-components'

const Hint = styled.div`
  font-size: 14px;
  line-height: 1.35;
  letter-spacing: 0.44px;
  color: #fff;
  margin-bottom: 45px;
`

const LoginCol = styled.div`
  width: 314px;
`

const Footer = styled.div`
  margin-top: 20px;
`

const inputStyle = {
  background: '#fff',
  border: 'solid 1.5px transparent',
  borderRadius: '5px',
  color: '#000'
}

export const s = { Hint, LoginCol, Footer, inputStyle }
